/**
 * @generated SignedSource<<fdf7aac99b30f00229cbe5a9dda58fdd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RestartIfFailedContentConfigType = "RestartIfFailedContent_BlockPermanently" | "RestartIfFailedContent_BlockPermanently_WhenRewarded" | "RestartIfFailedContent_BlockTemporarily" | "RestartIfFailedContent_BlockTemporarily_WhenRewarded" | "RestartIfFailedContent_CanNot" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProjectExtendRestartIfFailedContentConfigEditor_RestartIfFailedContentConfigFragment$data = {
  readonly configType: RestartIfFailedContentConfigType;
  readonly id: string;
  readonly " $fragmentType": "ProjectExtendRestartIfFailedContentConfigEditor_RestartIfFailedContentConfigFragment";
};
export type ProjectExtendRestartIfFailedContentConfigEditor_RestartIfFailedContentConfigFragment$key = {
  readonly " $data"?: ProjectExtendRestartIfFailedContentConfigEditor_RestartIfFailedContentConfigFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectExtendRestartIfFailedContentConfigEditor_RestartIfFailedContentConfigFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectExtendRestartIfFailedContentConfigEditor_RestartIfFailedContentConfigFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "configType",
      "storageKey": null
    }
  ],
  "type": "RestartIfFailedContentConfig",
  "abstractKey": "__isRestartIfFailedContentConfig"
};

(node as any).hash = "6b06d4852709a8b92c1e45e92b31bdc1";

export default node;
